import Vue from 'vue';
import { mapGetters } from 'vuex';
import formatter from '@/vue-utils/filters';
export default Vue.extend({
    name: 'coinCard',
    props: {
        name: {
            type: String,
            required: true,
            default: 'BNB'
        },
        value: {
            type: Object,
            required: false,
            default: null
        },
        type: {
            type: String,
            required: true,
            default: 'futures'
        }
    },
    computed: Object.assign(Object.assign({}, mapGetters('mainPageModules', {
        getFuturesAdditionalCoins: 'getFuturesAdditionalCoins',
        getFuturesDeposit: 'getFuturesDeposit',
        getSpotDeposit: 'getSpotDeposit'
    })), { formattedValue() {
            let currencyName = '';
            if (this.name === 'BTC')
                currencyName = 'BNB';
            else
                currencyName = this.name;
            const { formatToCurrencyMainWidgets, formatMoney } = formatter;
            return formatMoney(Number(formatToCurrencyMainWidgets(this.value, currencyName)), false);
        },
        coinTooltip() {
            const isFutures = this.type === 'futures';
            const source = isFutures ? this.getFuturesDeposit : this.getSpotDeposit;
            const name = isFutures ? this.name.toLowerCase() : this.name;
            return `${source[name]}`;
        } })
});
